var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.08392C0 0.933001 0.944756 0 2.11017 0H12.8898C14.0553 0 15 0.933001 15 2.08391V9.66723C15 10.8182 14.0552 11.7511 12.8898 11.7511H3.82931L0.918835 13.8878C0.744252 14.0159 0.511404 14.0359 0.317039 13.9395C0.122666 13.843 0 13.6465 0 13.4317V2.08392ZM2.11017 1.13668C1.58044 1.13668 1.151 1.56077 1.151 2.08392V12.301L3.2955 10.7267C3.39477 10.6539 3.51516 10.6145 3.63884 10.6145H12.8898C13.4195 10.6145 13.849 10.1904 13.849 9.66723V2.08391C13.849 1.56077 13.4195 1.13668 12.8898 1.13668H2.11017Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcons);
export default __webpack_public_path__ + "static/media/comment-icons.275599a45a92ba6f12328f7b5a96055d.svg";
export { ForwardRef as ReactComponent };